import {AsyncInlineError, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

import {UserErrorsFactory} from '../Errors/factory.js'
import UserRepositoriesFactory from '../Repositories/factory.js'
import UserServicesFactory from '../Services/factory.js'

class UploadAvatarUserUseCase extends UseCase {
  #config
  #repository
  #currentUserService
  #userNotLoggedInUserError

  constructor({config, repository, currentUserService, userNotLoggedInUserError}) {
    super()
    this.#config = config
    this.#repository = repository
    this.#currentUserService = currentUserService
    this.#userNotLoggedInUserError = userNotLoggedInUserError
  }

  static create({config}) {
    return new UploadAvatarUserUseCase({
      config,
      repository: UserRepositoriesFactory.httpUserRepository({config}),
      currentUserService: UserServicesFactory.getCurrentUserService({config}),
      userNotLoggedInUserError: UserErrorsFactory.userNotLoggedInUserError
    })
  }

  @tracer({metric: 'UploadAvatarUserUseCase#execute'})
  @AsyncInlineError()
  async execute({image}) {
    const userEntity = await this.#currentUserService.execute()

    if (!userEntity)
      return Promise.reject(
        this.#userNotLoggedInUserError({
          message: 'To upload avatar the user must be logged in'
        }).toJSON()
      )

    const [uploadAvatarError, uploadAvatarResponseVO] = await this.#repository.uploadAvatar({
      image,
      userEntity
    })

    return uploadAvatarError ? Promise.reject(uploadAvatarError) : uploadAvatarResponseVO.toJSON()
  }
}

export const factory = UploadAvatarUserUseCase.create
